import React from 'react'
import classNames from 'classnames'
import PropTypes from 'prop-types'

/** Color-only variants (from v7 badge/where styles). */
const VARIANT_CLASS = {
  blue: 'experience-badge-blue', // Prosperity where
  peach: 'experience-badge-peach', // Participant where
  taupe: 'experience-badge-taupe', // Admin where
  green: 'experience-badge-green', // success / live
  amber: 'experience-badge-amber', // warn / soon
  steel: 'experience-badge-steel', // in progress
  gray: 'experience-badge-gray', // completed / muted
  red: 'experience-badge-red', // fail / danger
  draft: 'experience-badge-draft', // unpublished
}

/**
 * Reusable badge — title is the label, variant is only the color style.
 *
 * @example
 * <ExperienceBadge title="Prosperity" variant="blue" />
 * <ExperienceBadge title="Participant" variant="peach" />
 * <ExperienceBadge title="Admin" variant="taupe" />
 * <ExperienceBadge title="Published" variant="green" />
 */
const ExperienceBadge = ({ title, variant = 'taupe', className, ...rest }) => (
  <span
    className={classNames(
      'experience-badge',
      VARIANT_CLASS[variant] || VARIANT_CLASS.taupe,
      className,
    )}
    {...rest}>
    {title}
  </span>
)

ExperienceBadge.propTypes = {
  title: PropTypes.string.isRequired,
  variant: PropTypes.oneOf(Object.keys(VARIANT_CLASS)),
  className: PropTypes.string,
}

export const EXPERIENCE_BADGE_VARIANTS = Object.keys(VARIANT_CLASS)

export default ExperienceBadge
